import { withLayout } from '../../layout';

import MembersPage from './members.page';

export default withLayout(MembersPage);
